// extracted by mini-css-extract-plugin
module.exports = {"postLogin":"MockInbox_postLogin__2HCV2"};